import { atom } from 'jotai'

/**
 * When true, dev-only chrome (the environment banner and performance monitor
 * bar) is hidden so the UI is clean for documentation screenshots. Intentionally
 * not persisted — a page refresh restores the normal view.
 */
export const screenshotModeAtom = atom(false)
